import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(private authService: AuthService) {}

  initStorage() {
    this.initToken();
  }

  initToken() {
    const access = this.authService.getAccessToken();
    const refresh = this.authService.getRefreshToken();

    if (access && refresh) {
      this.authService.setToken({ access, refresh });
    }
  }

  getDocument() {
    return localStorage.getItem('print-document');
  }

  storeDocument(document: string) {
    return localStorage.setItem('print-document', document);
  }

  removeDocument() {
    return localStorage.removeItem('print-document');
  }
}
